module.exports = __webpack_public_path__ + "static/media/boss-logo-green.3dccc2bd.png";